
export const FacultyAdvisor=[
    {
        name:"Prof. Kamal Sethi",
        linkedInUrl:"https://www.linkedin.com/in/kamalsethi/",
        imageURL:"https://res.cloudinary.com/dymfhvwou/image/upload/v1714037890/AITRCSI/1517457193606_nsxukv.jpg",
        position:"Convener"
    },
    {
        name:"Prof. NPS Rathore",
        linkedInUrl:"https://www.linkedin.com/in/narendrapalsinghrathore/",
        imageURL:"https://res.cloudinary.com/dymfhvwou/image/upload/v1714460656/AITRCSI/Edited_narendra_sir_jhtcaa.png",
        position:"Faculty Advisor"
    },
    {
        name:"Prof. Priyanka Jangde",
        linkedInUrl:"https://www.linkedin.com/in/priyanka-jangde-2489741a/",
        imageURL:"https://res.cloudinary.com/dymfhvwou/image/upload/v1710008540/AITRCSI/WhatsApp_Image_2024-03-09_at_23.51.49_8bb1f5ae_ggqevr.jpg",
        position:"Faculty Advisor"
    },
    {
        name:"Priyansh Gupta",
        linkedInUrl:"https://www.linkedin.com/in/pg1411",
        imageURL:"https://res.cloudinary.com/dymfhvwou/image/upload/v1714460184/AITRCSI/IMG_1052_-_Priyansh_Gupta_ufb9os.jpg",
        position:"Student Advisor"
    },

]

export const Lead=[
    {
        "name": "Kanishka Kanungo",
        "linkedInUrl": "www.linkedin.com/in/kanishka-kanungo-7b6262227",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710435899/AITRCSI/Kanishka_Kanungo_s9i0no.png",
        "position": "Chairperson"
    },
    {
        "name": "Shrina Jain",
        "linkedInUrl": "https://www.linkedin.com/in/shrina-jain-166bb3227/",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710435829/AITRCSI/Shrina_Jain_peu1wl.png",
        "position": "Chairperson"
    },
    {
        "name": "Nidhish Sharma",
        "linkedInUrl": "https://www.linkedin.com/me?trk=p_mwlite_feed_updates-secondary_nav",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710008646/AITRCSI/WhatsApp_Image_2024-03-09_at_23.53.18_b26d4083_crttvd.jpg",
        "position": "Vice Chairperson"
    },
    {
        "name": "Samarth Shukla",
        "linkedInUrl": "www.linkedin.com/in/samarth-shukla-0191a2271",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710436199/AITRCSI/Samarth_Shukla_v3l7af.jpg",
        "position": "Vice Chairperson"
    },
    {
        "name": "Anushka Shukla",
        "linkedInUrl": "https://www.linkedin.com/in/anushka-shukla-1b2b43252",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710436204/AITRCSI/Anushka_Shukla_erming.jpg",
        "position": "Secretary"
    },
    {
        "name": "Avanish Garg",
        "linkedInUrl": "https://www.linkedin.com/in/avanish-garg-90562b255?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710436203/AITRCSI/Avanish_Garg_ypkduo.jpg",
        "position": "Secretary"
    },
    {
        "name": "Shreyansh Sharma",
        "linkedInUrl": "https://www.linkedin.com/in/shreyansh-sharma-939697258?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710436199/AITRCSI/Shreyansh_Sharma_u8rbnz.png",
        "position": "Treasurer"
    },
    {
        "name": "Nishchal Vyas",
        "linkedInUrl": "https://www.linkedin.com/in/nishchal-vyas-393663238?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710008266/AITRCSI/IMG-20240224-WA0004_-_Nishchal_Vyas_z4yzof.jpg",
        "position": "Software Developer Lead"
    },
    {
        "name": "Aastha Kanade",
        "linkedInUrl": "www.linkedin.com/in/aastha-kanade-78076a2a0",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710436207/AITRCSI/Aastha_Kanade_nffsja.png",
        "position": "Event Head"
    },
    {
        "name": "Anay Mittal",
        "linkedInUrl": "https://www.linkedin.com/in/anay-mittal/",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710008266/AITRCSI/anay_mittal_white_bg_-_Anay_Mittal_hdj2po.png",
        "position": "Creative Head"
    },
    {
        "name": "Kartikey Gupta",
        "linkedInUrl": "https://www.linkedin.com/in/kartikey-gupta-b9ba71252",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710436201/AITRCSI/Kartikey_Gupta_yucwgp.png",
        "position": "PR Lead"
    },
    {
        "name": "Somesh Shukla",
        "linkedInUrl": "https://www.linkedin.com/in/somesh-shukla-02883823b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710436198/AITRCSI/Somesh_Shukla_xlsc1g.png",
        "position": "Engagement Head"
    }  
    
]

export const softwareTeam=[
    {
        "name": "Manan Atal",
        "linkedInUrl": "https://www.linkedin.com/in/manan-atal/",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710690771/AITRCSI/dummy1-removebg-preview_yo9l8k.png",
        "position": "Software Developer"
    },
    {
        "name": "Parth Gupta",
        "linkedInUrl": "https://www.linkedin.com/in/parth-guptaji",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710436200/AITRCSI/Parth_Gupta_uzbdd8.png",
        "position": "Software Developer"
    },
    {
        "name": "Aman Wairagkar",
        "linkedInUrl": "https://www.linkedin.com/in/aman-wairagkar-589a8a264",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710008265/AITRCSI/IMG-20240224-WA0013_-_Aman_Vishal_u5apmb.jpg",
        "position": "Software Developer"
    },
    {
        "name": "Tushar Jaiswal",
        "linkedInUrl": "www.linkedin.com/in/tushar-jaiswal-24130a28a",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710436195/AITRCSI/Tushar_Jaiswal_hcscad.jpg",
        "position": "Software Developer"
    },   
        
]

export const eventTeam=[
    {
        "name": "Kritika Rathore",
        "linkedInUrl": "https://www.linkedin.com/in/kritika-rathore-5b5092259?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710008642/AITRCSI/WhatsApp_Image_2024-03-09_at_23.53.01_c3f39b11_wqaof6.jpg",
        "position": "Event manager"
    },
    {
        "name": "Prakhar Patni",
        "linkedInUrl": "https://www.linkedin.com/in/prakhar-patni-177607277?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        "position": "Event Manager",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710690252/AITRCSI/Picsart_24-02-27_21-56-00-578_-_Prakhar_Patni_fhk5mt.jpg"
    },  
    
]


export const creativeTeam=[
    {
        "name": "Anhad Rana",
        "linkedInUrl": "https://www.linkedin.com/in/anhad-rana-978208251/",
        "position": "Creative Team Member",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710436205/AITRCSI/Anhad_Rana_l9pdre.png"
    },
    {
        "name": "Aman Garg",
        "linkedInUrl": "https://www.linkedin.com/in/aman-garg-841461261?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        "position": "Creative Team Member",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710691026/AITRCSI/aman_white_bg_-_AMAN_DHARMENDRA-removebg-preview_khmvej.png"
    },
    {
        "name": "Amisha Pandit",
        "linkedInUrl": "https://www.linkedin.com/in/amisha-pandit-54bb79269?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        "position": "Creative Team Member",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710008266/AITRCSI/IMG-20240227-WA0019_-_Amisha_Pandit_olinpb.jpg"
    },
    {
        "name": "Mranal Sawle",
        "linkedInUrl": "https://in.linkedin.com/in/mranal-sawle-9206b9265https://in.linkedin.com/in/mranal-sawle-9206b9265",
        "position": "Creative Team Member",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710436200/AITRCSI/Mranal_Sawle_qjtuac.jpg"
    }       
    
]


export const prTeam=[
    {
        "name": "Tanisha Gupta",
        "linkedInUrl": "https://www.linkedin.com/in/tanisha-gupta-83aa80268?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        "position": "PR Team Member",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710436197/AITRCSI/Tanisha_Gupta_s0auj2.jpg"
    },
    {
        "name": "Tanisha Agrawal",
        "linkedInUrl": "https://www.linkedin.com/in/tanishaagrawal18?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        "position": "PR Team Member",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710436197/AITRCSI/Tanisha_Agrawal_g1jxdj.jpg"
    }
        
]

export const engagementTeam=[
    {
        "name": "Sajal Mishra",
        "linkedInUrl": "https://www.linkedin.com/in/sajal-mishra-612396258/",
        "position": "Engagement Coordinator",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710436199/AITRCSI/Sajal_Mishra_qkel1c.png"
    },
    {
        "name": "Lakshy Raghuwanshi",
        "linkedInUrl": "https://www.linkedin.com/in/lakshya-raguwanshi-859a33162?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        "position": "Engagement Coordinator",
        "imageURL": "https://res.cloudinary.com/dymfhvwou/image/upload/v1710436201/AITRCSI/Lakshya_Raghuwanshi_esc83x.png"
    }   
]